import api from "../middlware/api";
import { camelToSnake } from "../utils/CamelToSnake";
import { BASE_URL } from "../constants";

const buildUserFormData = (payload: any) => {
  const formData = new FormData();

  const appendIfDefined = (key: string, value: any) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, String(value));
    }
  };

  // required fields: always append so Laravel sees them
  formData.append("first_name", payload.firstName ?? "");
  formData.append("last_name", payload.lastName ?? "");
  formData.append("phone", payload.phone ?? "");

  // optional fields
  appendIfDefined("middle_name", payload.middleName);
  appendIfDefined("email", payload.email);
  appendIfDefined("degree", payload.degree);
  appendIfDefined("registration_number", payload.registrationNumber);
  appendIfDefined("address", payload.address);
  appendIfDefined("preferred_language", payload.preferredLanguage);

  if (payload.defaultClinicVisitTypeId) {
    appendIfDefined(
      "default_clinic_visit_type_id",
      payload.defaultClinicVisitTypeId
    );
  }

  if (Array.isArray(payload.roles)) {
    payload.roles.forEach((role: any) => {
      if (role !== undefined && role !== null && role !== "") {
        formData.append("roles[]", String(role));
      }
    });
  }

  // Only append signature when it's actually a File/Blob (new upload)
  if (
    payload.signature &&
    (payload.signature instanceof File || payload.signature instanceof Blob)
  ) {
    formData.append("signature", payload.signature as Blob);
  }

  return formData;
};

export const getUsers = (params: any) => {
  let query = new URLSearchParams();
  for (let key in params) {
    query.set(key, params[key]);
  }
  return api.get(`${BASE_URL}/api/v1/users?${query.toString()}`);
};

export const getUserRoles = () => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/roles`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const saveUser = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/users`, buildUserFormData(payload), {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//get single user
export const getUser = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/users/${payload}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// export const updateUser = (payload: any) => {
//   return new Promise((resolve, reject) => {
//     api
//       .put(`${BASE_URL}/api/v1/users/${payload.id}`, camelToSnake(payload))
//       .then((res) => {
//         resolve(res.data);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const updateUser = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(
        `${BASE_URL}/api/v1/users/${payload.id}/update`,
        buildUserFormData(payload),
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateUserData = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/users/${payload.id}`, camelToSnake(payload))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const exportUsers = (params: any) => {
  return new Promise((resolve, reject) => {
    let query = new URLSearchParams();
    for (let key in params) {
      query.set(key, params[key]);
    }
    api
      .get(`${BASE_URL}/api/v1/export/users?${query.toString()}`, {
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getClinicUsers = () => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/clinics/users`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
